import {createSelector} from '@reduxjs/toolkit'

import {APIStatus} from '@web/core/constants'

import {RootState} from './interfaces'

export const paginationInfoSelector = createSelector(
    (state: RootState) => state.pagination,
    (pagination) => {
        return {
            total: pagination.total,
            current: pagination.current,
            start: pagination.start,
            end: pagination.end,
            isFirst: pagination.current === pagination.start,
            isLast: pagination.current === pagination.total,
        }
    },
)

export const infinitePaginationInfoSelector = createSelector(
    (state: RootState) => state.pagination.type,
    (state: RootState) => state.pagination.infinite,
    (type, {nextCursor, apiStatus}) => {
        return {
            type,
            nextCursor,
            hasNext: !!nextCursor,
            isPending: apiStatus === APIStatus.IDLE || apiStatus === APIStatus.FETCHING,
        }
    },
)
